"use client";

import { useRef } from "react";

import { BaseButton } from "@saas/shared/ui/base-button/base-button";
import {
  BaseDrawerModal,
  BaseDrawerModalProps,
} from "@saas/shared/ui/base-drawer-modal/base-drawer-modal";

export interface ILoyaltyAccountRegisteredModalProps
  extends Omit<
    BaseDrawerModalProps,
    "title" | "size" | "initialRef" | "testid" | "children"
  > {
  brandName: string;
  onRedirect: () => void;
  testid?: string;
}

export const LoyaltyAccountRegisteredModal = ({
  brandName,
  testid = "loyalty-register-success",
  onRedirect: handleRedirect,
  ...props
}: ILoyaltyAccountRegisteredModalProps) => {
  const initialRef = useRef<HTMLButtonElement | null>(null);

  return (
    <BaseDrawerModal
      title={"Akunmu telah selesai dibuat!"}
      size={"medium"}
      initialRef={initialRef}
      testid={testid}
      {...props}
    >
      <div className={"flex flex-col gap-6"}>
        <p
          className={"text-he body-b1"}
          data-testid={`${testid}__text__description`}
        >
          Sekarang, kamu bisa mulai menggunakan {brandName} Loyalti Program.
          Yuk, mulai eksplorasimu!
        </p>

        <BaseButton
          ref={initialRef}
          variant={"primary"}
          onClick={handleRedirect}
          testid={`${testid}__button__login`}
        >
          Lanjutkan Masuk Aplikasi
        </BaseButton>
      </div>
    </BaseDrawerModal>
  );
};
